import React, { useState, useContext } from 'react'
import { PAYMENT_TERMS_AND_CONDITION_LINKS } from '../../../constants'
import { Trans } from 'react-i18next'
import {
  Grid,
  Typography,
  FormControl,
  Box,
  withStyles
} from '@material-ui/core'
import MuiCheckBox from '@material-ui/core/Checkbox'
import { useTranslation } from 'react-i18next'
import { Context } from '../../../Store'
import { CHECKOUT_LAST_STEP } from './../../../constants'
import { ErrorMessage } from './../Forms/ErrorMessage'

const Checkbox = withStyles({
  root: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
    '&$checked': {
      color: '#0C9D9D',
    },
  },
  checked: {},
})(MuiCheckBox)

export const TermsAndConditionsBlock = () => {
  const [isTermsAndConditionsAccepted, setIsTermsAndConditionsAccepted] = useState(false);
  const [state, dispatch] = useContext(Context)
  const { t } = useTranslation()

  const onChangeIsTermsAndConditationsAccepted = (e) => {
    dispatch({ type: 'SET_TERMS_AND_CONDITIONS', payload: e.target.checked })
    setIsTermsAndConditionsAccepted(e.target.checked)
  }

  return (
    state?.current_step === CHECKOUT_LAST_STEP 
    && <Grid item xs={12} lg={11}>
          <FormControl fullWidth>
            <Grid item xs={12}>
              <Box paddingTop={2} />
              <a
                target="_blank"
                rel="noreferrer"
                href={t('booking.checkFaqLink')}
              >
                {' '}
                <Typography style={{ fontSize: '0.875rem', fontWeight: 700, color: '#000000' }}>{t('booking.checkFaq')}</Typography>{' '}
              </a>
            </Grid>
            <Box className="flex items-center" style={{ marginTop: '1.5rem' }}>
              <Checkbox onChange={onChangeIsTermsAndConditationsAccepted} checked={isTermsAndConditionsAccepted} />
              <Grid item xs={12} lg={10}>
                <Typography style={{ fontWeight: 400, fontSize: '1rem', color: '#757575', marginBottom: 0 }}>
                  <Trans
                    i18nKey="booking.paymentInfo.termsAndCondition.title"
                    components={{
                      1: (
                        <a
                          style={{ fontWeight: 700, fontSize: '1rem', color: '#0C9D9D', cursor: 'pointer' }}
                          href={PAYMENT_TERMS_AND_CONDITION_LINKS}
                          target="_blank"
                          rel="noreferrer"
                        />
                      ),
                    }}
                  />
                </Typography>
              </Grid>
            </Box>
            {state?.error?.terms_and_conditions !== true && <ErrorMessage error={state?.error?.terms_and_conditions} />}
          </FormControl>
        </Grid>
  )
}